import s from "./H1.module.scss"
import { IChildren } from "@/interfaces/IChildren"
import { FC } from "react"


const H1: FC<IChildren> = ({children}) => {
    return (
        <h1 className={s.h1}>{children}</h1>
    )
}

export default H1